export default __webpack_public_path__ + "static/media/9.accbb143.png";